export default __webpack_public_path__ + "img/error-404.0fa78c9c.svg";